import { graphql, useStaticQuery } from 'gatsby';

export default function HealthcareMenuLinks() {
  const HealthcareMenu = useStaticQuery(graphql`
    query HealthcareQuery {
      allMenuLinkContentHealthcare {
        nodes {
          id: drupal_id
          langcode
          parent: drupal_parent_menu_item
          link {
            uri
          }
          title
          weight
        }
      }
      allPathAliasPathAlias {
        nodes {
          alias
          langcode
          path
        }
      }
    }
  `);

  return HealthcareMenu;
}
